<template>
<div>Please wait...</div>
</template>

<script>
export default {
    created: function() {
        this.createForm().get('/afadmin/api/shops/' + this.pathParams().shop_id, function(response) {
            this.authenticate(response.data);
        }.bind(this));
    },
    methods: {
        authenticate: function(shop) {
            this.createForm().get('/shopadmin/api/start_session', function() {
                this.createForm({
                    'login_id': shop.user.login_id,
                    'password': shop.user.plain_password,
                    'su': true,
                    'redirect': this.query().redirect
                }).post('/shopadmin/api/login');
            });
        },
    }
};
</script>
